(ns boot.core
  (:require
    ;; @TODO remove me (see #1)
    ["react" :as react]

    [reagent.core :as r]
    [very.re-frame.core :as rf]
    [cljs.spec.alpha :as s]
    [css.core :as css]
    [oops.core :refer [oset!]]

    ;; the following requires are to include files that have side-effects on
    ;; initialization; there should only ever be a handful.
    [graphql.core]

    ;; NOTE: we must ensure all files that register handlers (a side effect) are
    ;; included before we attempt to start the app. by convention, any modules'
    ;; core namespace must handle this registration: <namespace.core.cljs>. this
    ;; means that the following require block dictates which features are
    ;; available and loaded into the app at compile time.
    [runtime.core :as rt :refer [DEBUG]]
    [boot.fx :as fx]
    [entities.core :as entities]
    [main.core]
    [client-onboard.core]
    [dashboard.core]
    [accounts.core]
    [guidebook.core]
    [notification.core]
    [profile.core]
    [priorities.core]
    [impersonate.core]
    [client-login.core]

    [router.core :as router]
    [modal.core :as modal]
    [loader.core :as loader]
    [authentication.core :as authentication]

    [very.http.core :as http]
    [very.sentry.core :as sentry]
    [main.views :refer [root]]
    [main.specs :as root-spec])

  (:require-macros
    [logging.core :refer [log]]))

;; #1 cljss requires js/React (but doesn't actually list it as a
;; dependency via cljsjs.react or some npm-module react). so we will
;; require reagent here, which does require cljsjs.react (and thanks
;; to shadowjs, an effect of requiring this will inject js/React
;; onto the page properly).
(oset! js/window "!React" react)

;; invoked when compiled js has been re-loaded into the browser
(defn on-js-reload [done]
  ;; in dev we want to auto-reload styles, so we have to cleanup any existing
  ;; ones then re-inject top-level (global) styles
  (css/remove-styles!)
  ;; if the previous build caused a rendering exception, clear it out
  (reset! main.views/root-error nil)
  (r/force-update-all)
  (done))

(rf/reg-fx :sentry sentry/fx)
(rf/reg-fx :insert-script fx/insert-script-fx)
;; this exists just to satisfy the re-frame errors, our :prevent-events is at
;; the interceptor level and not the reg-fx level
(rf/reg-fx :prevent-events identity)
(rf/reg-fx :entity entities/fx)
(rf/reg-fx :alert! fx/alert)
(rf/reg-fx :nav! router/nav-fx)
(rf/reg-fx :redirect! router/redirect-fx)
(rf/reg-fx :graphql http/graphql)
(rf/reg-fx :session authentication/session-fx)
(rf/reg-fx :inactivity authentication/inactivity-fx)
(rf/reg-fx :modal modal/modal)

(rf/reg-cofx :domain fx/domain)

(def carson-theme {:primary "#d7a900"
                   :secondary "#144633"
                   :tertiary "#84754e"})

(defn ^:export main [& args]
  (rt/set-env! (first (js->clj args :keywordize-keys true)))

  (sentry/init (rt/env))

  ;; perform any sync setup tasks here before we dispatch the initial event
  (when DEBUG (s/check-asserts true))

  ;; @TODO figure out how to link specs
  (when DEBUG (rf/set-spec! ::root-spec/root-spec))


  ;; set default theme
  (css/init-stylesheets)
  (css/set-theme! carson-theme)

  (rf/>evt! [:initialize-db])
  (r/render [root] (.getElementById js/document "app")))

  ;; enable dispatching from elsewhere
(when DEBUG
  (defn ^:export dispatch [& args]
    (let [v (vec args)
          kw (first v)]
      (rf/>evt (into [(keyword kw)] (js->clj (rest v) :keywordize-keys true))))))
